export const WALLET_NONCE_REQUEST = 'WALLET_NONCE_REQUEST';
export const WALLET_NONCE_SUCCESS = ' WALLET_NONCE_SUCCESS';
export const WALLET_NONCE_FAIL = ' WALLET_NONCE_FAIL';

export const SIWE_VERIFY_REQUEST = 'SIWE_VERIFY_REQUEST';
export const SIWE_VERIFY_SUCCESS = ' SIWE_VERIFY_SUCCESS';
export const SIWE_VERIFY_FAIL = ' SIWE_VERIFY_FAIL';
export const SIWE_VERIFY_RESET = 'SIWE_VERIFY_RESET';

export const WALLET_INFORMATION_REQUEST = 'WALLET_INFORMATION_REQUEST';
export const WALLET_INFORMATION_SUCCESS = ' WALLET_INFORMATION_SUCCESS';
export const WALLET_INFORMATION_FAIL = ' WALLET_INFORMATION_FAIL';
export const WALLET_INFORMATION_RESET = ' WALLET_INFORMATION_RESET';

export const READY_TO_SIGN_ONE_NEED_REQUEST = 'READY_TO_SIGN_ONE_NEED_REQUEST';
export const READY_TO_SIGN_ONE_NEED_SUCCESS = 'READY_TO_SIGN_ONE_NEED_SUCCESS';
export const READY_TO_SIGN_ONE_NEED_FAIL = 'READY_TO_SIGN_ONE_NEED_FAIL';
export const READY_TO_SIGN_ONE_NEED_RESET = 'READY_TO_SIGN_ONE_NEED_RESET';

export const CREATE_COMMENT_REQUEST = 'CREATE_COMMENT_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAIL = 'CREATE_COMMENT_FAIL';
export const CREATE_COMMENT_RESET = 'CREATE_COMMENT_RESET';

export const ONE_NEED_COLLECTIVE_RATIO_REQUEST = 'ONE_NEED_COLLECTIVE_RATIO_REQUEST';
export const ONE_NEED_COLLECTIVE_RATIO_SUCCESS = 'ONE_NEED_COLLECTIVE_RATIO_SUCCESS';
export const ONE_NEED_COLLECTIVE_RATIO_FAIL = 'ONE_NEED_COLLECTIVE_RATIO_FAIL';
export const ONE_NEED_COLLECTIVE_RATIO_RESET = 'ONE_NEED_COLLECTIVE_RATIO_RESET';

export const ONE_NEED_PERSONAL_RATIO_REQUEST = ' ONE_NEED_PERSONAL_RATIO_REQUEST';
export const ONE_NEED_PERSONAL_RATIO_SUCCESS = ' ONE_NEED_PERSONAL_RATIO_SUCCESS';
export const ONE_NEED_PERSONAL_RATIO_FAIL = ' ONE_NEED_PERSONAL_RATIO_FAIL';
export const ONE_NEED_PERSONAL_RATIO_REST = ' ONE_NEED_PERSONAL_RATIO_REST';

export const CONTRIBUTION_LIST_REQUEST = 'CONTRIBUTION_LIST_REQUEST';
export const CONTRIBUTION_LIST_SUCCESS = 'CONTRIBUTION_LIST_SUCCESS';
export const CONTRIBUTION_LIST_FAIL = 'CONTRIBUTION_LIST_FAIL';
export const CONTRIBUTION_LIST_RESET = 'CONTRIBUTION_LIST_RESET';

export const MY_READY_PAID_NEEDS_REQUEST = 'MY_READY_PAID_NEEDS_REQUEST';
export const MY_PAID_NEEDS_SUCCESS = 'MY_PAID_NEEDS_SUCCESS';
export const MY_PAID_NEEDS_FAIL = 'MY_PAID_NEEDS_FAIL';
export const MY_PAID_NEEDS_RESET = 'MY_PAID_NEEDS_RESET';

export const USER_SIGNATURES_REQUEST = 'USER_SIGNATURES_REQUEST';
export const USER_SIGNATURES_SUCCESS = 'USER_SIGNATURES_SUCCESS';
export const USER_SIGNATURES_FAIL = 'USER_SIGNATURES_FAIL';

export const SIGNATURE_PREPARE_REQUEST = 'SIGNATURE_PREPARE_REQUEST';
export const SIGNATURE_PREPARE_SUCCESS = 'SIGNATURE_PREPARE_SUCCESS';
export const SIGNATURE_PREPARE_FAIL = 'SIGNATURE_PREPARE_FAIL';
export const SIGNATURE_PREPARE_RESET = 'SIGNATURE_PREPARE_RESET';

export const SIGNATURE_HASH_REQUEST = 'SIGNATURE_HASH_REQUEST';
export const SIGNATURE_HASH_SUCCESS = 'SIGNATURE_HASH_SUCCESS';
export const SIGNATURE_HASH_FAIL = 'SIGNATURE_HASH_FAIL';
export const SIGNATURE_HASH_RESET = 'SIGNATURE_HASH_RESET';

export const SIGNATURE_VERIFICATION_REQUEST = 'SIGNATURE_VERIFICATION_REQUEST';
export const SIGNATURE_VERIFICATION_SUCCESS = 'SIGNATURE_VERIFICATION_SUCCESS';
export const SIGNATURE_VERIFICATION_FAIL = 'SIGNATURE_VERIFICATION_FAIL';
export const SIGNATURE_VERIFICATION_RESET = 'SIGNATURE_VERIFICATION_RESET';

export const SIGNATURE_CREATE_REQUEST = 'SIGNATURE_CREATE_REQUEST';
export const SIGNATURE_CREATE_SUCCESS = 'SIGNATURE_CREATE_SUCCESS';
export const SIGNATURE_CREATE_FAIL = 'SIGNATURE_CREATE_FAIL';
export const SIGNATURE_CREATE_RESET = 'SIGNATURE_CREATE_RESET';

export const GET_MILESTONES_REQUEST = 'GET_MILESTONES_REQUEST';
export const GET_MILESTONES_SUCCESS = 'GET_MILESTONES_SUCCESS';
export const GET_MILESTONES_FAIL = 'GET_MILESTONES_FAIL';

export const CREATE_MILESTONE_REQUEST = 'CREATE_MILESTONE_REQUEST';
export const CREATE_MILESTONE_SUCCESS = 'CREATE_MILESTONE_SUCCESS';
export const CREATE_MILESTONE_FAIL = 'CREATE_MILESTONE_FAIL';

export const ECOSYSTEM_MINT_REQUEST = 'ECOSYSTEM_MINT_REQUEST';
export const ECOSYSTEM_MINT_SUCCESS = 'ECOSYSTEM_MINT_SUCCESS';
export const ECOSYSTEM_MINT_FAIL = 'ECOSYSTEM_MINT_FAIL';
export const ECOSYSTEM_MINT_RESET = 'ECOSYSTEM_MINT_RESET';

export const FAMILY_ECOSYSTEM_PAYS_REQUEST = 'FAMILY_ECOSYSTEM_PAYS_REQUEST';
export const FAMILY_ECOSYSTEM_PAYS_SUCCESS = 'FAMILY_ECOSYSTEM_PAYS_SUCCESS';
export const FAMILY_ECOSYSTEM_PAYS_FAIL = 'FAMILY_ECOSYSTEM_PAYS_FAIL';
export const FAMILY_ECOSYSTEM_PAYS_REST = 'FAMILY_ECOSYSTEM_PAYS_REST';
